import Hero from '../components/home/Hero';
import Welcome from '../components/home/Welcome';
import ServicesPreview from '../components/home/ServicesPreview';
import Reviews from '../components/home/Reviews';
import usePageTitle from '../hooks/usePageTitle';

export default function Home() {
  usePageTitle();

  return (
    <>
      <Hero />
      <Welcome />
      <ServicesPreview />
      <Reviews />
    </>
  );
}
